var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtractionShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 277,
    viewBox: "0 0 1920 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M5255,9103h0V8826H7175v114.989L5255,9103Z",
    transform: "translate(-5255 -8826)",
    fill: "#09f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractionShape);
export default __webpack_public_path__ + "static/media/subtraction_shape.7ec968beed67f2220cff4de52b8a37f5.svg";
export { ForwardRef as ReactComponent };